import {PseudoBox} from "@chakra-ui/core";
import PlansFeaturesItem from "./PlansFeaturesItem";

const PlansFeaturesBlock: React.FC<{block: any}> = ({ block }) => {

    return (
        <PseudoBox py={3}>
            {block.features.map((feature, index) => {
            return (
                <PlansFeaturesItem feature={feature} key={index}/>
            )
            })}
        </PseudoBox>
    );
  };
  
  export default PlansFeaturesBlock;
  